$R.addLang('fr', {
    'ancre_name': 'Ancre',
    'ancre_title': "Nom de l'ancre"
});